import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { CommitteeMember, Society } from 'types';

import DetailsHeaderSection from 'modules/_shared/components/Sections/DetailsHeaderSection';
import DetailsContentSection from 'modules/_shared/components/Sections/DetailsContentSection';

type CommitteeMemberDetailsDocumentsTabProps = {
  member: CommitteeMember;
  society: Society;
};

const CommitteeMemberDetailsDocumentsTab: FC<
  CommitteeMemberDetailsDocumentsTabProps
> = ({ member, society }) => {
  const { t } = useTranslate();

  return (
    <>
      <DetailsHeaderSection
        title={t('Documents')}
        description={t('CommitteeMemberDocumentation', {
          name: member.name,
          societyName: society.name,
        })}
      />

      <DetailsContentSection>
        <div className="alert alert-icon alert-primary" role="alert">
          <em className="icon ni ni-alert-circle" />
          <strong>{t('ComingSoon')}!</strong>{' '}
          {t('CommitteeMemberDocumentsTabComingSoon')}
        </div>
      </DetailsContentSection>
    </>
  );
};

export default CommitteeMemberDetailsDocumentsTab;
